import React, {Component} from "react";
import {ApiGet} from "../../../shared/services/api-service";
import {normalizeOitReport} from "../../services/analytics";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import LogAnalytics from "../analytics/LogAnalytics";
import {viewingReport} from "../../store/reports/selectors";
import reportsActionCreators from "../../store/reports/action-creators";
import Checkbox from "../../../shared/forms/Checkbox";
import classNames from "classnames";
import Modal from "../../../shared/ui/Modal";

class DashboardLogReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedReport: props.type || 'rating',
      reportAnalytics: [],
      selectedQuestionIds: [],
      selectedPhasesMap: {},
      selectedFormTypes: props.departmentSettings.logOccurrenceFormTypes || ['dor', 'dor2', 'dor3', 'dor3', 'rdor','wor'],
      search: "",
      showFormTypeModal: false,
    }
  }

  componentDidMount() {
    this.props.oitGuids.forEach((oitGuid) => {
      this.setSelectedOit(oitGuid)
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.oitGuids.length !== this.props.oitGuids.length) {
      this.setState({
        reportAnalytics: this.state.reportAnalytics.filter(({oitGuid}) => {
          return this.props.oitGuids.includes(oitGuid)
        })
      })

      this.props.oitGuids.forEach((oitGuid) => {
        this.setSelectedOit(oitGuid)
      })
    }
  }

  get selectedOits() {
    return this.state.reportAnalytics.map(({oitGuid}) => this.getOit(oitGuid))
  }

  get oitsInProgress() {
    return this.props.oits
  }

  get currentForms() {
    if(!this.props.forms) {
      return []
    }

    return this.props.forms
      .filter(f => f.status === 'current')
      .filter(f => {
        if (this.critiqueFormTypes.includes(f.type)) {
          return this.props.canViewCritiqueForms;
        }
        return true
      })
  }

  get critiqueFormTypes() {
    return this.props.departmentSettings && this.props.departmentSettings.critiqueFormTypes ? this.props.departmentSettings.critiqueFormTypes : ['ftc'];
  }

  isFormTypeChecked(form) {
    return this.state.selectedFormTypes.includes(form.type)
  }

  getOit(oitGuid) {
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  setSelectedOit(oitGuid) {

    if (this.state.reportAnalytics.find((ra) => ra.oitGuid === oitGuid)) {
      return
    }

    let oit = this.getOit(oitGuid);

    if(!this.state.reportAnalytics.length) {
      this.setState({
        selectedPhasesMap: oit.trainingPhases
          .filter(tp => tp.type !== 'orientation')
          .reduce((acc, tp) => ({
            ...acc,
            [tp.sequence]: true
          }), {})
      })
    }

    this.setState({
      selectedOit: oitGuid,
      isLoading: true
    });


    ApiGet(`/api/v1/oits/${oitGuid}/training-phase-analytics/${this.state.selectedFormTypes.join(',')}`)
      .then((res) => {
        const reportAnalytics = normalizeOitReport(res, this.state.mapWeeksToPhaseStart);

        this.setState({
          isLoading: false,
          reportAnalytics: [...this.state.reportAnalytics, {
            raw: res,
            reportAnalytics,
            oitGuid,
            user: oit
          }],
          selectedQuestions: this.addQuestionsToFilter(reportAnalytics.questions),
          selectedQuestionIds: {
            ...this.state.selectedQuestionIds,
            ...reportAnalytics.questionsMapById
          },
        }, () => {
        });
      })
  }

  addQuestionsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question]: true
    }), {}), this.state.selectedQuestions)
  }

  updateSelectedPhases(sequence, checked) {
    this.setState({
      selectedPhasesMap: {
        ...this.state.selectedPhasesMap,
        [sequence]: checked
      }
    })

  }

  onReportClick(data) {
    this.props.setIsViewingReport(data);
  }

  handleFormTypeClick() {
    this.setState({
      showFormTypeModal: true
    });
  }

  closeFormTypeModal(e) {
    this.setState({
      showFormTypeModal: false
    });
    this.setState({
      reportAnalytics: []
    }, () => {
      this.props.oitGuids.forEach((oitGuid) => {
        this.setSelectedOit(oitGuid)
      })
    })
  }

  onFormTypeSelectChange(checked, form) {
    let selectedFormTypes = [...this.state.selectedFormTypes];
    if(checked) {
      selectedFormTypes = [...selectedFormTypes.filter(f => f !== form.type), form.type];
    } else {
      selectedFormTypes = selectedFormTypes.filter(f => f !== form.type);
    }

    this.setState({
      selectedFormTypes
    })


  }

  render() {
    return (
      <div className="dashboard-statistics-report">
        {this.state.reportAnalytics.length && !this.props.userContext.hasScope('oit') ? (
          <div className="selected-users">
            <div className="mr-2 mt-2">
              <button className="button secondary" onClick={() => this.handleFormTypeClick()}>
                <i className="fa fa-paperclip"/>
                Form types
              </button>
            </div>
            <br/>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {this.state.reportAnalytics[0].user.trainingPhases
                .filter(tp => tp.type !== 'orientation')
                .map(tp => (
                  <div key={tp.trainingPhaseGuid} style={{marginRight: '10px'}}>
                    <Checkbox
                      label={tp.header}
                      checked={this.state.selectedPhasesMap[tp.sequence]}
                      onChange={e => this.updateSelectedPhases(tp.sequence, e.target.checked)}
                    />
                  </div>
                ))}
            </div>
            <div>
              <input
                className={classNames('form-control')}
                type={'text'}
                placeholder={'Search logs'}
                value={this.state.search}
                onChange={(e) => this.setState({search: e.target.value})}
              />
            </div>
          </div>
        ) : null}
        {this.state.reportAnalytics.length > 0 && (
          <LogAnalytics
            reportAnalytics={this.state.reportAnalytics}
            selectedPhasesMap={this.state.selectedPhasesMap}
            reportClick={(viewingReport) => this.onReportClick(viewingReport)}
            searchValue={this.state.search}
          />
        )}
        <Modal
          fullscreen={true}
          title="Choose form types to display"
          isOpen={this.state.showFormTypeModal}
          onClose={(e) => this.closeFormTypeModal(e)}
          size="sm"
        >
          <div className="p-3">
            {this.currentForms.map(form => (
              <Checkbox
                key={form.type}
                checked={this.isFormTypeChecked(form)}
                label={form.name}
                onChange={(e) => {
                  this.onFormTypeSelectChange(e.target.checked, form)
                }}
              />
            ))}
            <div>
              <button className="button primary mt-3" onClick={() => this.closeFormTypeModal()}>
                Apply changes
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    viewingReport: state.reports.viewingReport,
    departmentSettings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    forms: state.forms.list,
    userContext: state.common.userContext,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardLogReport)
